import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDateFromPtBr } from '@/modules/core/utils/formats';
export const getEstatisticasCharts = async(filters) => {
  const params = getParams(filters);
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/estatisticas?${new URLSearchParams(params).toString()}`);
  return response.data;
};
const getParams = (options) => ({
  dataInicial: toDateFromPtBr(options.initialDate),
  dataFinal: toDateFromPtBr(options.endDate),
});
